import { useState } from 'react';
import { fetchPresignUrl } from '../utils/apiHelper';

export const useFileOperations = (user, callApi, setError) => {
    const [filesList, setFilesList] = useState(null);
    const [downloadKey, setDownloadKey] = useState('');
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadKey, setUploadKey] = useState('');

    const fetchFileList = async () => {
        try {
            const data = await callApi({ path: '/ts-file-service/list' });
            setFilesList(data);
        } catch (err) {
            console.error('Error fetching list:', err);
            setError(err);
        }
    };

    const downloadFileFromS3 = async () => {
        if (!downloadKey) {
            alert("No key specified for download");
            return;
        }

        try {
            const presignedUrl = await fetchPresignUrl(user, downloadKey, 'download');
            if (presignedUrl) {
                const link = document.createElement('a');
                link.href = presignedUrl.presigned_url;
                link.download = downloadKey.split('/').pop();

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (err) {
            console.error('Download failed:', err);
            setError(err);
        }
    };

    const deleteFileFromS3 = async () => {
        if (!downloadKey) {
            alert("No key specified for delete");
            return;
        }

        try {
            const result = await fetchPresignUrl(user, downloadKey, 'delete');
            if (result) {
                // Alert and show the result
                alert(result.status);
                // console log the result
                console.log(result);
            }
        } catch (err) {
            console.error('Delete Failed:', err);
            setError(err);
        }
    };

    const uploadFileToS3 = async () => {
        console.log('Attempting upload with:', { uploadFile, uploadKey });
        if (!uploadFile || !uploadKey) {
            alert("No upload file or key specified!");
            return;
        }

        try {
            const presignedUrl = await fetchPresignUrl(user, uploadKey, 'upload', uploadFile.type);
            if (!presignedUrl) {
                alert('Failed to fetch presigned URL');
                return;
            }

            const response = await fetch(presignedUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': uploadFile.type,
                },
                body: uploadFile,
            });

            if (!response.ok) throw new Error('Upload failed');

            alert(`File uploaded successfully as ${uploadKey}`);
            setUploadFile(null);
            setUploadKey('');
        } catch (err) {
            console.error('Upload failed:', err);
            setError(err);
        }
    };

    return {
        filesList,
        setFilesList,
        downloadKey,
        setDownloadKey,
        uploadFile,
        setUploadFile,
        uploadKey,
        setUploadKey,
        fetchFileList,
        downloadFileFromS3,
        deleteFileFromS3,
        uploadFileToS3,
        setError // Make setError available in the returned object
    };
};
